<template>

  <section class="section">
    <div class="container-lg">

      <div class="row">
        <div class="col-xl-9 col-lg-8">
          <div class="section__header">
            <h1 class="section__title  section__title--lg">{{ in18['page_title'] }}</h1>
            <div v-if="!is_auth" class="section__text">
              <p><span v-html="in18['page_authorize_text']"></span></p>
              <p class="fw-500">
                <a class="link  link--primary" :href="register_link">
                  <span v-html="in18['page_authorize_link']"></span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div><!-- .row -->

      <div class="row  flex-column-reverse  flex-lg-row">
        <div class="col-xl-9 col-lg-8">
          <form class="form  form--checkout" @submit.prevent="processCheckout">
            <div class="form__fieldset">
              <h3 class="form__title">
                {{ in18['page_contact_info'] }}
              </h3>
              <div v-if="!is_auth" class="form__group--md  form__group--flex">
                <div class="radio">
                  <input
                      id="type_b2c"
                      v-model="order.user_type"
                      :disabled="inProgress"
                      class="radio__input"
                      name="type"
                      type="radio"
                      value="b2c"
                  >
                  <label class="radio__label" for="type_b2c">
                    {{ in18['attribute_type_individual'] }}
                  </label>
                </div>
                <div class="radio">
                  <input
                      id="type_b2b"
                      v-model="order.user_type"
                      :disabled="inProgress"
                      class="radio__input"
                      name="type"
                      type="radio"
                      value="b2b"
                  >
                  <label class="radio__label" for="type_b2b">
                    {{ in18['attribute_type_legal'] }}
                  </label>
                </div>
                <validation-error :errors="errors['order.user_type']"/>
              </div><!-- user_type -->

              <div class="row">
                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input
                        id="user_name"
                        v-model="order.user_name"
                        :class="{'error' : errors['order.user_name']}"
                        :disabled="inProgress"
                        class="form-control"
                        name="user_name"
                        type="text"
                        @input="clearValidationError('order.user_name')"
                    >
                    <label class="form-label" for="user_name">
                      {{ in18['attribute_user_name'] }}
                      <validation-error :errors="errors['order.user_name']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-user"></use>
                    </svg>
                  </div>
                </div><!-- user_name -->

                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input
                        id="user_surname"
                        v-model="order.user_surname"
                        :class="{'error' : errors['order.user_surname']}"
                        :disabled="inProgress"
                        class="form-control"
                        name="user_surname"
                        type="text"
                        @input="clearValidationError('order.user_surname')"
                    >
                    <label class="form-label" for="user_surname">
                      {{ in18['attribute_user_surname'] }}
                      <validation-error :errors="errors['order.user_surname']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-user"></use>
                    </svg>
                  </div>
                </div><!-- user_surname -->

                <div class="col-lg-6">
                  <div class="form__group  form__group--md">
                    <input
                        id="user_email"
                        v-model="order.user_email"
                        :class="{'error' : errors['order.user_email']}"
                        :disabled="inProgress"
                        :readonly="is_auth"
                        class="form-control"
                        name="user_email"
                        type="email"
                        @input="clearValidationError('order.user_email')"
                    >
                    <label class="form-label" for="user_email">
                      {{ in18['attribute_user_email'] }}
                      <validation-error :errors="errors['order.user_email']"/>
                    </label>
                    <svg class="form-control-icon">
                      <use href="#form-email"></use>
                    </svg>
                  </div>
                </div><!-- user_email -->

                <div class="col-lg-6">
                  <TelFormField
                      :id="'mobile_phone_number'"
                      v-model="order.user_phone_number"
                      :errors="phoneErrors"
                      :label="in18['attribute_user_phone']"
                      name="mobile_phone_number"
                      @update:model-value="clearValidationError('order.user_phone_number.number');clearValidationError('order.user_phone_number.countryCallingCode')"/>
                </div><!-- user_phone -->

                <template v-if="order.user_type === 'b2b'">

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_name"
                          v-model="order.company_name"
                          :class="{'error' : errors['order.company_name']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_name"
                          type="text"
                          @input="clearValidationError('order.company_name')"
                      >
                      <label class="form-label" for="company_name">
                        {{ in18['attribute_company_name'] }}
                        <validation-error :errors="errors['order.company_name']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div><!-- company_name -->

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_reg_num"
                          v-model="order.company_reg_num"
                          :class="{'error' : errors['order.company_reg_num']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_reg_num"
                          type="text"
                          @input="clearValidationError('order.company_reg_num')"
                      >
                      <label class="form-label" for="company_reg_num">
                        {{ in18['attribute_company_reg_number'] }}
                        <validation-error :errors="errors['order.company_reg_num']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div><!-- company_reg_num -->

                  <div class="col-12">
                    <div class="form__group  form__group--md">
                      <div class="checkbox">
                        <input
                            id="company_is_not_vat_payer"
                            v-model="isNotVatPayer"
                            :disabled="inProgress || is_auth"
                            class="checkbox__input"
                            name="company_is_not_vat_payer"
                            type="checkbox"
                            @change="isNotVatPayer ? order.company_vat_num = null : null"
                        >
                        <label class="checkbox__label" for="company_is_not_vat_payer">
                          {{ in18['attribute_not_vat_payer'] }}
                        </label>
                      </div>
                    </div>
                  </div><!-- company_is_not_vat_payer -->

                  <div v-if="!isNotVatPayer" class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_vat_num"
                          v-model="order.company_vat_num"
                          :class="{'error' : errors['order.company_vat_num']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_vat_num"
                          type="text"
                          @input="clearValidationError('order.company_vat_num')"
                      >
                      <label class="form-label" for="company_vat_num">
                        {{ in18['attribute_company_tax_number'] }}
                        <validation-error :errors="errors['order.company_vat_num']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-building"></use>
                      </svg>
                    </div>
                  </div><!-- company_vat_num -->

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_address"
                          v-model="order.company_address"
                          :class="{'error' : errors['order.company_address']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_address"
                          type="text"
                          @input="clearValidationError('order.company_address')"
                      >
                      <label class="form-label" for="company_address">
                        {{ in18['attribute_company_address'] }}
                        <validation-error :errors="errors['order.company_address']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div><!-- company_address -->

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_city"
                          v-model="order.company_city"
                          :class="{'error' : errors['order.company_city']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_city"
                          type="text"
                          @input="clearValidationError('order.company_city')"
                      >
                      <label class="form-label" for="company_city">
                        {{ in18['attribute_company_city'] }}
                        <validation-error :errors="errors['order.company_city']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div><!-- company_city -->

                  <div class="col-lg-6">
                    <div class="form__group  form__group--md">
                      <input
                          id="company_zip"
                          v-model="order.company_zip"
                          :class="{'error' : errors['order.company_zip']}"
                          :disabled="inProgress"
                          :readonly="is_auth"
                          class="form-control"
                          name="company_zip"
                          type="text"
                          @input="clearValidationError('order.company_zip')"
                      >
                      <label class="form-label" for="company_zip">
                        {{ in18['attribute_company_zip'] }}
                        <validation-error :errors="errors['order.company_zip']"/>
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div><!-- company_zip -->
                </template>
              </div><!-- /.row -->
            </div><!-- /.form__fieldset -->

            <checkout-shipping
                :cart="cart"
                :errors="errors"
                :in-progress="inProgress"
                :in18="in18"
                :shipping="shipping"
                @update-error="updateError"
                @update-cart="updateCart"
                @update-shipping-method="updateShippingMethod"
                @update-in-progress="updateInProgress"
            /><!-- /.form__fieldset -->

            <checkout-payment
                v-if="selectedShippingMethod !== null"
                :cart="cart"
                :errors="errors"
                :in-progress="inProgress"
                :in18="in18"
                :selected-shipping-method="selectedShippingMethod"
                @update-payment-method="updatePaymentMethod"
                @update-in-progress="updateInProgress"
            /><!-- /.form__fieldset -->

            <div class="row">
              <div class="col-lg-6">
                <div class="form__group  form__group--md">
                  <button :disabled="inProgress" class="btn  btn--block  btn--red  btn--md" type="submit">
                    {{ in18['page_process_order_btn'] }} ({{ cart.formatted_total_price_with_tax }})
                  </button>
                </div>
              </div>
            </div><!-- /.row -->

            <div class="form__text">
              <div class="checkbox">
                <input class="checkbox__input" type="checkbox" name="terms" id="terms" v-model="termsAccepted">
                <label v-if="['tt_fi_tel_shop', 'fi_tel_shop'].includes(shop_code)" class="checkbox__label" for="terms">
                  {{ in18['page_terms_accept'] }}
                  <a :href="terms_second_link" :title="in18['page_terms_accept_second_title']"
                     class="link  link--primary  fw-500" target="_blank">
                    {{ in18['page_terms_accept_second_title'] }}
                  </a>
                </label>
                <label v-else class="checkbox__label" for="terms">
                  {{ in18['page_terms_accept'] }}
                  <a :href="terms_first_link" :title="in18['page_terms_accept_first_title']"
                     class="link  link--primary  fw-500" target="_blank">
                    {{ in18['page_terms_accept_first_title'] }}
                  </a>
                  {{ in18['page_terms_accept_and'] }}
                  <a :href="terms_second_link" :title="in18['page_terms_accept_second_title']"
                     class="link  link--primary  fw-500" target="_blank">
                    {{ in18['page_terms_accept_second_title'] }}
                  </a>
                </label>
              </div>
              <validation-error :errors="errors['terms_accepted']"/>
            </div>
          </form>
        </div><!-- /.col -->
        <div class="col-xl-3 col-lg-4">
          <div class="h-max w-full sticky top-[161px]">
            <checkout-summary
                :cart="cart"
                :in-progress="inProgress"
                :in18="in18"
                @process-checkout="processCheckout"
            />
            <cart-coupon
                :cart="cart"
                :in-progress="inProgress"
                :in18="in18"
                @update-cart="updateCart"
                @update-in-progress="updateInProgress"
            />
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>
</template>

<script>

import ValidationError from '../features/ValidationError.vue';
import CartCoupon from '../components/cart/CartCoupon.vue';
import CheckoutSummary from '../components/checkout/CheckoutSummary.vue';
import CheckoutShipping from "../components/checkout/CheckoutShipping.vue";
import CheckoutPayment from "../components/checkout/CheckoutPayment.vue";
import TelFormField from '../components/form-field/TelFormField.vue'

export default {

  components: {
    'cart-coupon':       CartCoupon,
    'checkout-summary':  CheckoutSummary,
    'validation-error':  ValidationError,
    'checkout-shipping': CheckoutShipping,
    'checkout-payment':  CheckoutPayment,
    TelFormField
  },

  props: {
    is_auth:           {
      type:    Number,
      default: false,
    },
    in18:              {
      type: Object
    },
    terms_first_link:  {
      type:    String,
      default: '',
    },
    terms_second_link: {
      type:    String,
      default: '',
    },
    phone_code:        {
      type: String
    },
    country_id:        {
      type: String
    },
    register_link:     {
      type: String
    },
    shop_code: {
      type: String
    }
  },

  data() {
    return {

      cart:          {},
      errors:        [],
      inProgress:    true,
      isNotVatPayer: false,
      termsAccepted: false,

      selectedShippingMethod: null,
      selectedPaymentMethod:  null,

      shipping: {
        identifier:        null,
        country_id:        this.country_id,
        region_id:         null,
        area_id:           null,
        city:              '',
        village:           '',
        building_num:      '',
        house_num:         '',
        address:           '',
        zip:               '',
        user_phone_number: {
          countryCallingCode: this.phone_code,
          number:             null
        },
        message:           '',
      },

      order: {
        user_type:          'b2c',
        user_name:          '',
        user_surname:       '',
        user_email:         '',
        user_phone_number:  {
          countryCallingCode: this.phone_code,
          number:             null
        },
        company_name:       '',
        company_reg_num:    '',
        company_vat_num:    '',
        company_address:    '',
        company_city:       '',
        company_zip:        '',
        company_country_id: this.country_id,
      }
    };
  },

  created() {
    Promise.all([
      this.getCart(),
      this.getUser()
    ])
        .then(([cartResponse, userResponse]) => {
          this.shipping.user_phone_number = cartResponse?.shipping_address?.phone
              ? cartResponse.shipping_address.phone
              : Object.assign({
                countryCallingCode: this.phone_code,
                number:             null
              }, userResponse?.data?.user?.phone)
          this.inProgress = false;
        })
  },

  computed: {
    isDisabledBtnSendOrder() {
      return this.inProgress ||
          this.cart.shipping_method === null ||
          this.cart.payment_method === null;
    },
    phoneErrors() {
      let errors = []
      if (this.errors['order.user_phone_number.number']) {
        errors = errors.concat(this.errors['order.user_phone_number.number'])
      }
      if (this.errors['order.user_phone_number.countryCallingCode']) {
        errors = errors.concat(this.errors['order.user_phone_number.countryCallingCode'])
      }
      return errors
    }
  },

  methods: {

    updateError(key, data) {
      this.errors[key] = data;
    },

    updateCart(newCart) {
      // console.debug('emit::updateCart');
      // console.debug(newCart);
      this.cart = newCart;
    },

    updateInProgress(inProgress) {
      if (inProgress === false) {
        setTimeout(() => {
          this.inProgress = false;
        }, 1000);
      } else {
        this.inProgress = inProgress;
      }
      // console.debug('emit::updateInProgress');
      // console.debug(inProgress);
    },

    updatePaymentMethod(paymentMethod) {
      // console.debug('emit::updatePaymentMethod');
      // console.debug(paymentMethod);
      this.errors = [];
      this.clearValidationError('payment_method');
      this.selectedPaymentMethod = paymentMethod;
      this.cart.payment_method = paymentMethod;
      this.inProgress = false;
    },

    updateShippingMethod(shippingMethod) {
      // console.debug('emit::updateShippingMethod');
      // console.debug(shippingMethod);
      this.errors = [];
      this.selectedShippingMethod = shippingMethod;
      this.selectedPaymentMethod = null;
    },

    getCart() {
      return axios.get('/api/cart').then((response) => {
        let cart = response.data.cart;

        ga_begin_checkout_event(response.data.cart);

        this.cart = cart;
        this.selectedShippingMethod = cart.shipping_method ? cart.shipping_method : null;
        this.selectedPaymentMethod = cart.payment_method ? cart.payment_method : null;

        this.shipping.identifier = cart.shipping_address?.identifier ? cart.shipping_address.identifier : null;
        this.shipping.region_id = cart.shipping_address?.region_id ? cart.shipping_address.region_id : null;
        this.shipping.area_id = cart.shipping_address?.area_id ? cart.shipping_address.area_id : null;
        this.shipping.city = cart.shipping_address?.area_id ? cart.shipping_address.area_id : null;
        this.shipping.village = cart.shipping_address?.village ? cart.shipping_address.village : null;
        this.shipping.building_num = cart.shipping_address?.building_num ? cart.shipping_address.building_num : null;
        this.shipping.house_num = cart.shipping_address?.house_num ? cart.shipping_address.house_num : null;
        this.shipping.address = cart.shipping_address?.address ? cart.shipping_address.address : null;
        this.shipping.zip = cart.shipping_address?.zip ? cart.shipping_address.zip : null;
        this.shipping.message = cart.shipping_address?.message ? cart.shipping_address.message : null;
        return response
      });
    },

    getUser() {
      return axios.get('/api/user').then((response) => {

        let user = response.data.user;

        if (!user) {
          return;
        }

        this.order.user_type = user.type;
        this.order.user_name = user.name;
        this.order.user_surname = user.surname;
        this.order.user_email = user.email;
        this.order.user_phone_number = user.phone;

        if (user.type === 'b2b') {
          this.order.company_name = user.company.name;
          this.order.company_reg_num = user.company.reg_num;
          this.order.company_vat_num = user.company.vat_num;
          this.order.company_address = user.company.address;
          this.order.company_city = user.company.city;
          this.order.company_zip = user.company.zip;
          this.order.company_country_id = user.company.country ? user.company.country.id : this.country_id;
          this.isNotVatPayer = !user.company.vat_num;
        }

        return response
      });
    },

    clearValidationError(fieldName) {
      if (this.errors[fieldName]) {
        this.errors[fieldName] = null;
      }
    },

    processCheckout() {

      if (this.inProgress) {
        return;
      }

      this.inProgress = true;

      let data = {
        'order':           this.order,
        'shipping':        this.shipping,
        'shipping_method': this.selectedShippingMethod?.code,
        'payment_method':  this.selectedPaymentMethod?.code,
        'terms_accepted':  this.termsAccepted,
      };

      axios.post('/api/order/store', data)
          .then((response) => {
            ga_purchase_event(response.data.order);
            window.location.href = response.data.payment_link;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            this.errors = error.response.data.errors;
            window.scrollToErrorMessage();
            this.inProgress = false;
          });
    }
  },
};
</script>
